<div class="banner" role="banner">
  <h1 class="text-white" *ifScreenSize="screenType.Desktop">{{ 'contact.us.page.title' | translate }}</h1>
  <h1 class="text-white mob-banner" *ifScreenSize="screenType.Mobile">{{ 'contact.us.page.title' | translate }}</h1>
</div>
<fgbcl-contact-us></fgbcl-contact-us>
